import { InputStyled } from "./style";

export const Input = ({
  label,
  type,
  placeholder,
  register,
  className,
  min,
  max,
  onInput,
  onKeyUp,
  id,
  value,
  label2,
  disabled = false
}) => {
  return (
    <InputStyled className={className}>
      <label>{label}</label>
      {label2 && <label className="label2">{label2}</label>}
      <input
        type={type}
        placeholder={placeholder}
        min={min}
        max={max}
        {...register}
        onInput={onInput}
        onKeyUp={onKeyUp}
        id={id}
        disabled={disabled}
        {...(value !== undefined && value !== null ? { value } : {})}
      />
    </InputStyled>
  );
};
